import type { ComputedRef } from "vue";
import { computed } from "vue";
import { useCurrentDistributionContentQuery } from "./useCurrentDistributionContentQuery";

export function useIsCurrentExperienceOpinoia(): ComputedRef<boolean> {
  const distributionContentQuery = useCurrentDistributionContentQuery();

  const isOpinoia = computed(() => distributionContentQuery.data.value?.experience_source === "INTERNAL");

  return isOpinoia;
}
